import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import { LaundryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import ReceiveLaundryForm from "./Componates/ReceiveLaundryForm";
import fields from "../json/LaundryFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { validateItems } from "../Helper/validateItems"
import {
    Receive,
    GetAllProduct,
    GetAllEmployees,
    GetAllTask,
    GetById
} from "adminApi/LaundryApi/Laundry.js";

const ReceiveLaundry = () => {
    const navigate = useNavigate();
    const { formdata, item } = fields;
    const { id } = useParams()

    // Initialize form values
    const allFields = useMemo(
        () => [...formdata, { "name": "items" }],
        []
    );

    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    const {
        values,
        errors,
        handleChange,
        setValues,
        setErrors
    } = useFormChange(
        initialValues,
        LaundryRules
    );

    // Fetch existing data by ID
    const {
        loading: loadingFetch
    } = useFetchFormDataById(
        id,
        allFields,
        GetById,
        setValues
    );

    // Fetch products
    const {
        data: ProductOptions = []
    } = useFetchAllData(
        GetAllProduct
    );

    // Fetch Employees
    const {
        data: EmployeesOptions = []
    } = useFetchAllData(
        GetAllEmployees
    );

    // Fetch Task
    const {
        data: TaskOptions = []
    } = useFetchAllData(
        GetAllTask
    );

    // Form Submite
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();

            Object.entries(formValues).forEach(([key, val]) => {
                if (key === "items") {
                    formData.append("items", JSON.stringify(val));
                } else {
                    formData.append(key, val ?? "");
                }
            });

            return await Receive({id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, LaundryRules);
            const itemErrors = validateItems(vals.items);
            if (itemErrors) err.items = itemErrors;
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Laundry received successfully."
    )

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <ReceiveLaundryForm
                fields={formdata}
                values={values}
                setValues={setValues} // pass setValues to sync items
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                item={item}
                ProductOptions={ProductOptions}
                EmployeesOptions={EmployeesOptions}
                TaskOptions={TaskOptions} // pass merged tasks here
                validateItems={validateItems}
                setErrors={setErrors}
            />
        </>
    );
};

export default ReceiveLaundry;
